import { render, staticRenderFns } from "./select-payment-method-bank.vue?vue&type=template&id=728ef05b&"
import script from "./select-payment-method-bank.vue?vue&type=script&lang=js&"
export * from "./select-payment-method-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports